/**
 * Adobe Font (Typekit) Project ID and Font ID inputs.
 * Used when "Custom Adobe Font" is selected in the font family field.
 */
import VStack from "@ui-kit/layout/Stack/VStack.web";
import Box from "@ui-kit/layout/Box/Box.web";
import Text from "@ui-kit/typography/Text/Text.web";
import Input from "@ui-kit/form/Input/Input.web";
import { useTranslation } from "@shared/utils/internationalization";

export interface AdobeFontInputsProps {
  projectId: string;
  fontId: string;
  onProjectIdChange: (value: string) => void;
  onFontIdChange: (value: string) => void;
}

export function AdobeFontInputs({
  projectId,
  fontId,
  onProjectIdChange,
  onFontIdChange,
}: AdobeFontInputsProps): JSX.Element {
  const { t } = useTranslation("common");

  return (
    <VStack align="stretch" gap="sm" p="sm" bg="bg.subtle" borderRadius="sm">
      <Text fontSize="xs" fontWeight="medium" color="fg.muted">
        {t("Adobe Fonts project ID and font ID from your Typekit kit.")}
      </Text>
      <VStack align="stretch" gap="xs">
        <Box>
          <Text
            as="label"
            fontSize="xs"
            fontWeight="medium"
            mb="2xs"
            display="block"
          >
            {t("Project ID")}
          </Text>
          <Input
            value={projectId}
            onChange={(e) => onProjectIdChange(e.target.value)}
            placeholder={t("e.g. abc12")}
            size="sm"
          />
        </Box>
        <Box>
          <Text
            as="label"
            fontSize="xs"
            fontWeight="medium"
            mb="2xs"
            display="block"
          >
            {t("Font ID")}
          </Text>
          <Input
            value={fontId}
            onChange={(e) => onFontIdChange(e.target.value)}
            placeholder={t("e.g. source-sans-pro")}
            size="sm"
          />
        </Box>
      </VStack>
    </VStack>
  );
}
